import type { StatusActivityStatus } from '@shared/patient-intake-status';

const throwNever = (status: never) => {
  throw new Error(`Status does not exist: ${status}`);
};

type StatusColour = {
  colour: 'success' | 'gold' | 'error' | 'inherit';
  main: string;
};

export const getStatusColour = (status: StatusActivityStatus): StatusColour => {
  switch (status) {
    case 'COMPLETED':
      return { colour: 'success', main: 'success.main' };
    case 'PENDING':
      return { colour: 'gold', main: 'gold.main' };
    case 'ERROR':
      return { colour: 'error', main: 'error.main' };
    case 'NOT_STARTED':
      return { colour: 'inherit', main: 'rgba(0, 0, 0, 0.5)' };
    default:
      return throwNever(status);
  }
};
